import React, { Component } from 'react';
import { ReCaptcha } from 'react-recaptcha-v3'

class RecaptchaV3Component extends Component {

  constructor(props) {
    super(props);
    this.state = {
      token: ''
    }
  }

  verifyCallback = (recaptchaToken) => {
    this.setState({ token: recaptchaToken })
  }

  render() {
    return (
      <div>
        <ReCaptcha
            sitekey="6LfeNKsUAAAAANSlpAAxKqGFNttkZ1XBcQVR1Nuw"
            action='formulario'
            verifyCallback={this.verifyCallback}
        />
        <input type='hidden' name='token' id='token' value={this.state.token} />
      </div>
    );
  };
};

export default RecaptchaV3Component;